import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import { useWizard } from "@/components/wizard/WizardProvider";

// Auto-start the guided tour once, the first time a user logs in with no
// onboardingCompletedAt on their account yet. The server field (not
// localStorage) is the source of truth, so it fires exactly once per
// account regardless of browser/device. WizardProvider marks it complete
// server-side when the tour finishes or is skipped. (Users can re-launch
// the tour manually at any time via TourLauncherButton.)
export function useFirstLoginTour() {
  const { user } = useAuth();
  const { startTour } = useWizard();
  const startedFor = useRef<string | null>(null);

  useEffect(() => {
    if (!user) return;
    const role = user.role;
    if (role !== "ADMIN" && role !== "BOARD_MEMBER" && role !== "RESIDENT") return;
    if (user.onboardingCompletedAt) return;
    if (startedFor.current === user.id) return;
    startedFor.current = user.id;
    const id = window.setTimeout(() => startTour(role), 600);
    return () => window.clearTimeout(id);
  }, [user, startTour]);
}
